import { Copy } from '@stokr/components-library'
import type { CopyKey } from 'locales/copy-keys.gen'
import { StatusBox, StatusIcon, StatusText, StatusTitle } from './KeyActions.styles'

export interface NoticeProps {
  /** Figma InfoBox: green for a done/open state, yellow for something to do or unavailable. */
  variant: 'success' | 'warning'
  titleKey: CopyKey
  /** Only where the text carries content of its own (the risk acknowledgement); the panels show the title alone. */
  textKey?: CopyKey
  /** Placeholders in the copy, e.g. `{ venue }`. */
  values?: Record<string, string>
}

/** The yellow / green info box shared by the Invest, Trade and Redeem panels. */
export const Notice = ({ variant, titleKey, textKey, values }: NoticeProps) => (
  <StatusBox $variant={variant} $compact={!textKey}>
    <StatusIcon $variant={variant} aria-hidden="true" />
    <div>
      <StatusTitle>
        <Copy id={titleKey} values={values} />
      </StatusTitle>
      {textKey && (
        <StatusText>
          <Copy id={textKey} values={values} />
        </StatusText>
      )}
    </div>
  </StatusBox>
)
